import { render, staticRenderFns } from "./m-article-stats.vue?vue&type=template&id=723c1fd5&scoped=true"
import script from "./m-article-stats.vue?vue&type=script&lang=js"
export * from "./m-article-stats.vue?vue&type=script&lang=js"
import style0 from "./m-article-stats.vue?vue&type=style&index=0&id=723c1fd5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723c1fd5",
  null
  
)

export default component.exports